import * as Preact from "preact"

import Dev from "@frog/source/views/dev/Dev.view.js"
import App from "@frog/source/views/app/App.view.js"

import "@frog/source/views/Mount.view.less"

export default class Mount {
    render() {
        // <Dev/>
        return (
            <div class="Mount">
                <App/>
            </div>
        )
    }
}
